import React, { useState, useCallback } from 'react';
import { Toaster } from 'sonner';
import { translations } from './translations';
import {
  Header,
  Hero,
  IntroSection,
  WhoForSection,
  PatentedSection,
  Configurator,
  Gallery,
  VideoSection,
  ContactForm,
  Footer
} from './components/sections';
import './App.css';

function App() {
  const [language, setLanguage] = useState('bg');
  const [configSummary, setConfigSummary] = useState('');
  const t = translations[language];

  const scrollToSection = useCallback((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  // Handler for reactive config changes (updates on every selection change)
  const handleConfigChange = useCallback((summary) => {
    setConfigSummary(summary);
  }, []);

  // Handler for when user clicks "Send Inquiry" in configurator
  const handleSendInquiry = useCallback(() => {
    // Just scroll to form - config is already up to date
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="urban-cage-app">
      {/* Toast notifications */}
      <Toaster position="top-center" richColors />
      
      {/* Skip to main content link (accessibility) */}
      <a href="#main-content" className="skip-link">
        {language === 'bg' ? 'Прескочи към съдържанието' : 'Skip to main content'}
      </a>
      
      {/* Header */}
      <Header 
        t={t} 
        language={language} 
        setLanguage={setLanguage} 
        scrollToSection={scrollToSection} 
      />

      <main id="main-content" role="main">
        {/* Hero Section */}
        <Hero 
          t={t} 
          language={language} 
          scrollToSection={scrollToSection} 
        />

        {/* Intro Text Section */}
        <IntroSection t={t} />

        {/* Who Is Urban Cage For */}
        <WhoForSection t={t} language={language} />

        {/* UrbanCage in Numbers */}
        <PatentedSection t={t} />

        {/* Cage Configurator */}
        <Configurator 
          t={t} 
          language={language} 
          onConfigChange={handleConfigChange}
          onSendInquiry={handleSendInquiry}
        />

        {/* Image Gallery */}
        <Gallery t={t} language={language} />

        {/* Video Section */}
        <VideoSection t={t} language={language} />

        {/* Contact Form */}
        <ContactForm 
          t={t} 
          language={language} 
          configurationSummary={configSummary}
        />
      </main>

      {/* Footer */}
      <Footer 
        t={t} 
        language={language} 
        setLanguage={setLanguage} 
        scrollToSection={scrollToSection} 
      />
    </div>
  );
}

export default App;
